import React from "react";

type SectionCardProps = {
  icon: React.ReactNode;
  title: string;
  children: React.ReactNode;
};

const SectionCard: React.FC<SectionCardProps> = ({ icon, title, children }) => {
  return (
    <div className="mx-auto max-w-6xl overflow-hidden rounded-2xl bg-white shadow-md">
      <div className="flex items-center gap-3 bg-gradient-to-r from-[#0B1526] to-[#123324] px-6 py-5 sm:px-8">
        <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-primary-500/15 text-primary-400">
          {icon}
        </span>
        <h2 className="font-serif text-xl font-medium text-white">{title}</h2>
      </div>
      <div className="px-6 py-8 sm:px-8">{children}</div>
    </div>
  );
};

export default SectionCard;
